import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import FormLocCasa from '../../components/FormLocCasa/FormLocCasa';
import AlterarSenha from '../../components/AlterarSenha/AlterarSenha';
import { obterConta, removerToken } from '../../services/api';
import styles from './ClienteHome.module.css';

export default function ClienteHome() {
  const [mostrarAlterarSenha, setMostrarAlterarSenha] = useState(false);
  const conta = obterConta();
  const navigate = useNavigate();

  const handleLogout = () => {
    removerToken();
    navigate('/cliente');
  };

  return (
    <>
      <Header />
      <main className={styles.container}>
        <section className={styles.sessaoConta}>
          <div>
            <strong>Conta logada:</strong> {conta?.nome || 'Cliente'} ({conta?.email || 'sem email'})
          </div>
          <div className={styles.acoesConta}>
            <span className={styles.badgeCliente}>cliente</span>
            <button
              type="button"
              className={styles.botaoSecundario}
              onClick={() => setMostrarAlterarSenha((atual) => !atual)}
            >
              {mostrarAlterarSenha ? 'Fechar' : 'Alterar senha'}
            </button>
            <button type="button" onClick={handleLogout}>Sair</button>
          </div>
        </section>

        {mostrarAlterarSenha && <AlterarSenha />}

        <section className={styles.blocoTitulo}>
          <h1>Cadastre seu imóvel</h1>
          <p>Como cliente, você pode cadastrar seu imóvel. Alterações e remoções são feitas pela equipe administrativa.</p>
        </section>

        <FormLocCasa />
      </main>
      <Footer />
    </>
  );
}
